import { apiCall } from '../../utils/restclient'
import {
  GET_DRUG_RULES_SETTINGS,
  GET_DRUG_RULES_SETTINGS_ERROR,
  GET_DRUG_RULES_SETTINGS_SUCCESS,
} from './drugRulesSettingsConstants'

export function getDrugRulesSettings() {
  const endpoint = 'api/v1/settings'
  const action = {
    type: GET_DRUG_RULES_SETTINGS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_DRUG_RULES_SETTINGS_SUCCESS,
      error: GET_DRUG_RULES_SETTINGS_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
